// ElevenLabs Conversational AI Agent Configuration
export const AGENT_CONFIG = {
  // Replace with your actual ElevenLabs agent ID
  // You can get this from: https://elevenlabs.io/app/conversational-ai
  AGENT_ID: process.env.REACT_APP_ELEVENLABS_AGENT_ID || 'your-actual-agent-id-here',
  
  // For production, you might want to use signed URLs instead
  // This would require a backend endpoint to generate signed URLs
  USE_SIGNED_URL: false,
  
  // API endpoint for generating signed URLs (if using signed URLs)
  SIGNED_URL_ENDPOINT: '/api/elevenlabs/signed-url',
  
  // Demo mode settings
  DEMO_MODE: {
    ENABLED: true, // Set to false to disable demo mode fallback
    WELCOME_MESSAGE: "Hi! I'm your Crel AI voice agent. This is demo mode - configure your agent ID to enable real voice conversations."
  }
};

// Helper function to get the agent configuration
export const getAgentConfig = () => {
  return {
    agentId: AGENT_CONFIG.AGENT_ID,
    useSignedUrl: AGENT_CONFIG.USE_SIGNED_URL,
    demoMode: AGENT_CONFIG.DEMO_MODE
  };
}; 